import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { BOOKING_URL, OWNER } from "../mock/mock";

const HERO_SLIDES = [
  OWNER.cymyran_exterior,
  OWNER.cymyran_living1
];

export default function Hero() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setIdx((i) => (i + 1) % HERO_SLIDES.length);
    }, 6000);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="relative h-screen min-h-[640px] w-full overflow-hidden">
      {HERO_SLIDES.map((src, i) => (
        <div
          key={src}
          className="hero-bg hero-slide"
          style={{
            backgroundImage: `url(${src})`,
            opacity: idx === i ? 1 : 0
          }}
        />
      ))}
      <div className="hero-overlay" />

      <div className="relative z-10 h-full flex items-center justify-center px-6">
        <div className="text-center text-white fade-in">
          <div className="text-[11px] md:text-xs tracking-[0.35em] uppercase text-forge-gold mb-6">
            Forge Stays · Anglesey · North Wales
          </div>
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-tight max-w-4xl mx-auto">
            Comfortable Anglesey Stays.
          </h1>
          <p className="mt-6 text-white/85 tracking-wide max-w-2xl mx-auto text-sm md:text-base">
            A growing collection of thoughtfully designed places to stay across Anglesey —
            from Newry Street in Holyhead to Hotel Cymyran in Valley. Ideal for contractors,
            consultants and holidaymakers alike.
          </p>
          <div className="mt-10">
            <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="btn-outline-cream">
              Check Availability
            </a>
          </div>

          {/* Slide indicators */}
          <div className="mt-10 flex items-center justify-center gap-2">
            {HERO_SLIDES.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                aria-label={`Show slide ${i + 1}`}
                className="w-8 h-1 rounded-full transition-colors"
                style={{ backgroundColor: idx === i ? "var(--forge-gold)" : "rgba(255,255,255,0.35)" }}
              />
            ))}
          </div>
        </div>
      </div>

      <a href="#about" className="chev-down" aria-label="Scroll down">
        <ChevronDown size={30} strokeWidth={1.5} />
      </a>
    </section>
  );
}
